import styled from "styled-components"

export const ToastWrapperComponentStyled = styled.div`

    .MuiPopper-root {
        
        background-color: red !important;
    }
`